export default (cellPhone: string): string => (cellPhone ? cellPhone.replace(/^0+/, '') : '')
